import { REACT_QUERY_KEYS } from '@/constants'

export const additionalPaymentCategoriesQueryKeys = {
  all: [REACT_QUERY_KEYS.ADDITIONAL_PAYMENT_CATEGORIES] as const,
  select: (tenantKey: string) =>
    [...additionalPaymentCategoriesQueryKeys.all, 'select', tenantKey] as const
}
